import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  inject,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { noop, Subscription } from "rxjs";
import { filter, tap } from "rxjs/operators";
import { OptionOpenService } from "@ng-falcon/controls/option/option-open.service";
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: 'ngf-options-search-box',
    templateUrl: './options-search-box.component.html',
    styleUrls: ['./options-search-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatIcon
    ]
})
export class OptionsSearchBoxComponent implements OnInit, OnDestroy {

  @Input()
  placeholder = 'Search';

  @Output()
  searchChange = new EventEmitter<string>();

  @ViewChild('searchInput')
  protected searchInput: ElementRef;

  private sub = Subscription.EMPTY;

  private openService: OptionOpenService = inject(OptionOpenService);

  ngOnInit(): void {
    this.sub = this.openService.opened$.pipe(
      filter(opened => opened),
      tap(() => this.focusSearchInput())
    ).subscribe(noop);
  }

  focusSearchInput() {
    if (!this.searchInput?.nativeElement) {
      return;
    }

    setTimeout(() => {
      this.searchInput.nativeElement.focus();
    });
  }

  handleSearchChange() {
    this.searchChange.emit(this.searchInput?.nativeElement.value);
  }

  clearSearchValue(event: Event) {
    event.preventDefault();
    if (!!this.searchInput?.nativeElement) {
      this.searchInput.nativeElement.value = '';
    }
    this.searchChange.emit('');
    this.focusSearchInput();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

}
